var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DEFAULT_TRACKER_NAME, Tracker } from './tracker';
import { addTracker, getTracker } from './tracker-store';
export function initialize(options) {
    var logHub = options.logHub, _a = options.trackerName, trackerName = _a === void 0 ? DEFAULT_TRACKER_NAME : _a, topic = options.topic;
    var tracker = new Tracker(__assign(__assign({}, logHub), { topic: topic }));
    addTracker(trackerName, tracker);
    return;
}
export function set(fieldsObject) {
    var tracker = getTracker(DEFAULT_TRACKER_NAME);
    if (!tracker) {
        return;
    }
    tracker.set(fieldsObject);
}
export function pageview(page, options) {
    var tracker = getTracker(DEFAULT_TRACKER_NAME);
    if (!tracker) {
        return;
    }
    tracker.pageview(page, options);
}
export function event(args, data) {
    var tracker = getTracker(DEFAULT_TRACKER_NAME);
    if (!tracker) {
        return;
    }
    var eventFields = {
        eventCategory: args.category,
        eventAction: args.action,
    };
    if (args.label) {
        eventFields.eventLabel = args.label;
    }
    if (args.value && Number.isNaN(args.value)) {
        eventFields.eventValue = +args.value;
    }
    tracker.event(eventFields, data);
}
export default {
    event: event,
    initialize: initialize,
    pageview: pageview,
    set: set,
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../tracker/build/src/index.js
// module id = 1114
// module chunks = 0